import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

function AnimatedActivityItem({ activity, index }) {
  return (
    <motion.div 
      className="flex py-3"
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ 
        duration: 0.5, 
        delay: 0.3 + (index * 0.15),
        ease: "easeOut"
      }}
    >
      <motion.div 
        className="flex-shrink-0 mr-3"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ 
          duration: 0.5, 
          delay: 0.4 + (index * 0.15),
          ease: "easeOut"
        }}
      >
        <div className="h-8 w-8 rounded-full bg-primary-50 flex items-center justify-center">
          {activity.icon}
        </div>
      </motion.div>
      
      <div className="flex-1 border-b pb-3">
        <div className="flex items-center justify-between">
          <motion.p 
            className="text-sm font-medium"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ 
              duration: 0.3, 
              delay: 0.5 + (index * 0.15)
            }}
          >
            {activity.title}
          </motion.p>
          
          <motion.span 
            className="text-xs text-gray-500 flex items-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ 
              duration: 0.3, 
              delay: 0.5 + (index * 0.15)
            }}
          >
            <Clock className="h-3 w-3 mr-1" />
            {activity.time}
          </motion.span>
        </div>
        
        <motion.p 
          className="text-sm text-gray-600 mt-1"
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 0.3, 
            delay: 0.6 + (index * 0.15)
          }}
        >
          {activity.description}
        </motion.p>
      </div>
    </motion.div>
  );
}

function AnimatedActivityList({ activities }) {
  return (
    <motion.div 
      className="space-y-0"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div 
        className="flex items-center justify-between mb-4"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <h2 className="text-lg font-medium">Recent Activity</h2>
        <motion.button 
          className="text-primary text-sm font-medium flex items-center hover:text-primary-700"
          whileHover={{ x: 3 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <span>View All</span>
          <motion.span 
            className="ml-1"
            animate={{ x: [0, 3, 0] }}
            transition={{ 
              repeat: Infinity, 
              repeatType: "reverse", 
              duration: 1,
              repeatDelay: 1
            }}
          >
            →
          </motion.span>
        </motion.button>
      </motion.div>
      
      {activities.map((activity, index) => (
        <AnimatedActivityItem 
          key={activity.id} 
          activity={activity} 
          index={index} 
        />
      ))}
    </motion.div>
  );
}

export default AnimatedActivityList;